module.exports = __webpack_public_path__ + "static/media/AaronDasani.2e69e852.jpg";